const MAX_STATE_NAME_LENGTH: number = 15;

export function abbreviateStateName(name: string): string {
  return `${name.split(' ')[0]}...`;
}

export function formatPlaceName(name: string, isState: boolean = false): string {
  if (!name) return '';
  if (isState && name.length > MAX_STATE_NAME_LENGTH) return abbreviateStateName(name);
  return name.toLowerCase()
    .split(' ')
    .filter((each: string): boolean => !!each?.length)
    .map((each: string): string => `${each[0]}`.toUpperCase() + each.slice(1))
    .join(' ');
}
